export const iowa = {
  "19000": "Iowa",
  "19001": "Adair County",
  "19003": "Adams County",
  "19005": "Allamakee County",
  "19007": "Appanoose County",
  "19009": "Audubon County",
  "19011": "Benton County",
  "19013": "Black Hawk County",
  "19015": "Boone County",
  "19017": "Bremer County",
  "19019": "Buchanan County",
  "19021": "Buena Vista County",
  "19023": "Butler County",
  "19025": "Calhoun County",
  "19027": "Carroll County",
  "19029": "Cass County",
  "19031": "Cedar County",
  "19033": "Cerro Gordo County",
  "19035": "Cherokee County",
  "19037": "Chickasaw County",
  "19039": "Clarke County",
  "19041": "Clay County",
  "19043": "Clayton County",
  "19045": "Clinton County",
  "19047": "Crawford County",
  "19049": "Dallas County",
  "19051": "Davis County",
  "19053": "Decatur County",
  "19055": "Delaware County",
  "19057": "Des Moines County",
  "19059": "Dickinson County",
  "19061": "Dubuque County",
  "19063": "Emmet County",
  "19065": "Fayette County",
  "19067": "Floyd County",
  "19069": "Franklin County",
  "19071": "Fremont County",
  "19073": "Greene County",
  "19075": "Grundy County",
  "19077": "Guthrie County",
  "19079": "Hamilton County",
  "19081": "Hancock County",
  "19083": "Hardin County",
  "19085": "Harrison County",
  "19087": "Henry County",
  "19089": "Howard County",
  "19091": "Humboldt County",
  "19093": "Ida County",
  "19095": "Iowa County",
  "19097": "Jackson County",
  "19099": "Jasper County",
  "19101": "Jefferson County",
  "19103": "Johnson County",
  "19105": "Jones County",
  "19107": "Keokuk County",
  "19109": "Kossuth County",
  "19111": "Lee County",
  "19113": "Linn County",
  "19115": "Louisa County",
  "19117": "Lucas County",
  "19119": "Lyon County",
  "19121": "Madison County",
  "19123": "Mahaska County",
  "19125": "Marion County",
  "19127": "Marshall County",
  "19129": "Mills County",
  "19131": "Mitchell County",
  "19133": "Monona County",
  "19135": "Monroe County",
  "19137": "Montgomery County",
  "19139": "Muscatine County",
  "19141": "O",
  "19143": "Osceola County",
  "19145": "Page County",
  "19147": "Palo Alto County",
  "19149": "Plymouth County",
  "19151": "Pocahontas County",
  "19153": "Polk County",
  "19155": "Pottawattamie County",
  "19157": "Poweshiek County",
  "19159": "Ringgold County",
  "19161": "Sac County",
  "19163": "Scott County",
  "19165": "Shelby County",
  "19167": "Sioux County",
  "19169": "Story County",
  "19171": "Tama County",
  "19173": "Taylor County",
  "19175": "Union County",
  "19177": "Van Buren County",
  "19179": "Wapello County",
  "19181": "Warren County",
  "19183": "Washington County",
  "19185": "Wayne County",
  "19187": "Webster County",
  "19189": "Winnebago County",
  "19191": "Winneshiek County",
  "19193": "Woodbury County",
  "19195": "Worth County",
  "19197": "Wright County",
};
